import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Name from './Name';
import Email from './Email';
import Mobile from './Mobile';
import Gender from './Gender';
import Birthday from './Birthday/Birthday';
import Address from './Address';

const ProfileFields = (props) => {
	const { t } = useTranslation();

	const {form_component} = props;

	switch (form_component.fieldname) {
		case 'name':
			return (
				<Name
					lang={props.lang}
					form_component={form_component}
				/>
			);

		case 'email':
			return (
				<Email
					lang={props.lang}
					form_component={form_component}
				/>
			);

		case 'mobile':
			return (
				<Mobile
					lang={props.lang}
					form_component={form_component}
				/>
			);

		case 'gender':
			return (
				<Gender
					lang={props.lang}
					formFields={props.formFields}
					form_component={form_component}
				/>
			);

		case 'birthday':
			return (
				<Birthday
					lang={props.lang}
					form_component={form_component}
				/>
			);

		case 'address':
			return (
				<Address
					lang={props.lang}
					form_component={form_component}
				/>
			);

		default:
			return <></>;
	}
}

export default ProfileFields;